import { buildApplicationReviewUrl } from "@workspace/dto/email/destinations";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import { defineEmailNotificationHandler, requireOrganizationId } from "./types";

const ApplicationNewSchema = z.object({
  applicationId: z.string(),
  jobId: z.string(),
  candidateName: z.string(),
  jobTitle: z.string(),
});

export const applicationNewHandler = defineEmailNotificationHandler({
  type: "application.new",
  icon: "application",
  title(metadata) {
    const jobTitle =
      typeof metadata.jobTitle === "string" && metadata.jobTitle.trim()
        ? metadata.jobTitle
        : undefined;
    return `New application${jobTitle ? ` for ${jobTitle}` : ""}`;
  },
  description(metadata) {
    const candidateName =
      typeof metadata.candidateName === "string" &&
      metadata.candidateName.trim()
        ? metadata.candidateName
        : undefined;
    const jobTitle =
      typeof metadata.jobTitle === "string" && metadata.jobTitle.trim()
        ? metadata.jobTitle
        : undefined;
    return candidateName
      ? `${candidateName} applied${jobTitle ? ` for ${jobTitle}` : ""}.`
      : "A candidate applied to your job listing.";
  },
  schema: ApplicationNewSchema,
  buildNotificationPayload(data, _ctx) {
    return {
      metadata: {
        applicationId: data.applicationId,
        jobId: data.jobId,
        candidateName: data.candidateName,
        jobTitle: data.jobTitle,
      },
      links: {
        href: `/jobs/${data.jobId}/applications/${data.applicationId}`,
        label: "View candidate",
      },
    };
  },
  buildEmailPayload(
    data,
    recipient,
    { baseUrl, organizationId, unsubscribeUrl }
  ) {
    return {
      name: "email/application.new",
      data: {
        organizationId: requireOrganizationId({ organizationId }),
        to: recipient.email,
        from: buildFromAddress(),
        recipientName: recipient.name,
        candidateName: data.candidateName,
        jobTitle: data.jobTitle,
        applicationReviewUrl: buildApplicationReviewUrl({
          applicationId: data.applicationId,
          baseUrl,
          jobId: data.jobId,
        }),
        unsubscribeUrl,
      },
    };
  },
});
